import uiConfig from 'src/lib/ui/config';
import ImageScaleView from '@play-co/timestep-core/lib/ui/ImageScaleView';
import LangBitmapFontTextView from '../../lib/ui/components/LangBitmapFontTextView';
import i18n from 'src/lib/i18n/i18n';
import ButtonScaleView from '../../lib/ui/components/ButtonScaleView';
import { MinigameType } from 'src/replicant/minigame';
import { View } from '@play-co/timestep-core/ui';
import StateObserver from '../../StateObserver';

namespace ui {
  export const container = <const>{
    offsetX: 20,
    offsetY: 10,
    width: uiConfig.popups.buruburu.width - 100,
    height: 199,
  };

  export const frame = <const>{
    image: 'assets/ui/shared/lossless/scroller_panel_blue.png',
    width: container.width,
    height: container.height,
    scaleMethod: '9slice',
    sourceSlices: {
      horizontal: {
        left: 19,
        right: 22,
      },
      vertical: {
        top: 19,
        bottom: 28,
      },
    },
  };

  export const icon = <const>{
    scaleMethod: 'contain',
    x: 18,
    y: 21,
    width: 146,
    height: 146,
  };

  export const name = <const>{
    font: 'Body',
    color: '#9A7171',
    verticalAlign: 'top',
    y: 18,
    x: 172,
    height: 38,
    size: 32,
    width: container.width - 196,
  };

  export const underline = <const>{
    x: name.x,
    y: 55,
    height: 2,
    width: name.width,
    backgroundColor: '#AED3F0',
  };

  export const description = <const>{
    size: 32,
    font: 'Body',
    color: '#7191AB',
    align: 'left',
    x: name.x,
    y: 64,
    height: 112,
    width: name.width,
  };
}

export class MinigameTile {
  readonly view: ButtonScaleView;

  constructor(opts: { type: MinigameType; onClick: () => Promise<void> }) {
    this.view = new ButtonScaleView({
      ...ui.container,
      pressedOffsetY: 5,
      onClick: opts.onClick,
      tracking: { feature: 'minigame', $subFeature: opts.type },
    });

    // Frame
    this.view.addSubview(new ImageScaleView({ ...ui.frame }));

    // icon
    this.view.addSubview(
      new ImageScaleView({
        ...ui.icon,
        image: `assets/minigame/${opts.type}.png`,
      }),
    );

    // name
    this.view.addSubview(
      new LangBitmapFontTextView({
        ...ui.name,
        localeText: () => i18n(`minigame.${opts.type}.title`),
      }),
    );

    // underline
    this.view.addSubview(new View(ui.underline));

    // description
    const { locale } = StateObserver.getState().ui;
    this.view.addSubview(
      new LangBitmapFontTextView({
        ...ui.description,
        wordWrap: locale === 'en',
        localeText: () => i18n(`minigame.${opts.type}.description`),
      }),
    );
  }
}
